'use client';

import React from 'react';
import { motion } from 'framer-motion';
import { Warehouse, Box, ShoppingBag, Truck } from 'lucide-react';
import styles from './FulfillmentDemo.module.css';

const steps = [
    { icon: Box, title: 'Приём товара' },
    { icon: Warehouse, title: 'Хранение' },
    { icon: ShoppingBag, title: 'Обработка заказов' },
    { icon: Truck, title: 'Доставка в маркетплейсы' },
];

const marketplaces = [
    { name: 'Wildberries', color: '#7B1FA2', bgColor: '#F3E5F5' },
    { name: 'Ozon', color: '#0288D1', bgColor: '#E1F5FE' },
    { name: 'Яндекс', color: '#FFB300', bgColor: '#FFF8E1' },
];

export const FulfillmentDemo = () => {
    return (
        <motion.div
            className={styles.container}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <motion.div
                className={styles.statsCard}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
            >
                <div className={styles.statsValue}>5000+ м²</div>
                <div className={styles.statsDescription}>
                    складских помещений с температурным контролем
                </div>
            </motion.div>

            <motion.button
                className={styles.actionButton}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
                whileHover={{ y: -2 }}
                whileTap={{ scale: 0.98 }}
            >
                Подключить фулфилмент
            </motion.button>

            {/* Process Steps Timeline */}
            <div className={styles.timelineContainer}>
                <div className={styles.timelineLine} />

                {steps.map((step, index) => (
                    <motion.div
                        key={index}
                        className={styles.timelineItem}
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: 0.3 + index * 0.1 }}
                    >
                        <motion.div
                            className={styles.timelineIconWrapper}
                            whileHover={{ scale: 1.1 }}
                        >
                            <step.icon className={styles.timelineIcon} />
                        </motion.div>
                        <div className={styles.timelineContent}>
                            <h4 className={styles.timelineTitle}>{step.title}</h4>
                        </div>
                    </motion.div>
                ))}
            </div>

            {/* Marketplaces */}
            <div className={styles.marketplacesGrid}>
                {marketplaces.map((mp, index) => (
                    <motion.div
                        key={index}
                        className={styles.marketplaceCard}
                        style={{ backgroundColor: mp.bgColor, color: mp.color }}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.7 + index * 0.1 }}
                        whileHover={{ scale: 1.05 }}
                    >
                        {mp.name}
                    </motion.div>
                ))}
            </div>
        </motion.div>
    );
};
